'use client'

import { usePathname } from 'next/navigation'

/**
 * Bramka sklepowego chrome (Header/Footer/asystent/cookies): panel admina ma własny
 * pełnoekranowy layout i sklepowa nawigacja z mega-menu + stopka z chipami dostawy
 * wyglądały tam nieprofesjonalnie. Children są server-rendered (slot) — ukrywamy
 * tylko na /admin, bez podwójnego renderu po stronie klienta.
 */
export function SiteChrome({ children }: { children: React.ReactNode }) {
  const pathname = usePathname()
  if (pathname.startsWith('/admin')) return null
  return <>{children}</>
}
